"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jsx_runtime_1 = require("react/jsx-runtime");
require("../../styles/global.scss");
var ProductBanner_1 = __importDefault(require("../../components/ProductBanner"));
var preact_1 = require("preact");
var PaymentMethodDescriptionOdlozTo_1 = __importDefault(require("../../components/PaymentMethodDescriptionOdlozTo"));
var PaymentMethodDescriptionRozlozTo_1 = __importDefault(require("../../components/PaymentMethodDescriptionRozlozTo"));
var PaymentMethodCode_1 = __importDefault(require("../../enums/PaymentMethodCode"));
var PaymentMethods = __importStar(require("./payment-methods"));
var ApplicationIframe_1 = __importDefault(require("../../components/ApplicationIframe"));
var gtag = __importStar(require("./gtag"));
var GTagEvent_1 = __importDefault(require("../../enums/GTagEvent"));
var AHOJ_GTAGS = { development: "none", test: "G-BGHS9YJ9Y9", production: "G-YG6NJVCYJQ" };
var Ahoj = /** @class */ (function () {
    function Ahoj(config) {
        var _a;
        this.config = config;
        this.availablePaymentMethods = [];
        this.availablePaymentMethods = config.paymentMethods;
        // inject gtag script based on mode ('development' by default)
        gtag.injectScript(AHOJ_GTAGS[(_a = config.mode) !== null && _a !== void 0 ? _a : "development"]).then(function () { });
    }
    ;
    /**
     * Returns available Ahoj payment methods for given item price.
     * @param {number} itemPrice: The price of the eshop item.
     */
    Ahoj.prototype.getAvailablePaymentMethodsForItemPrice = function (itemPrice) {
        return this.availablePaymentMethods.filter(function (paymentMethod) { return PaymentMethods.isAvailableForItemPrice(paymentMethod, itemPrice); });
    };
    Ahoj.prototype.renderProductBanner = function (selector, productBannerPayload) {
        var selectorElement = typeof selector === "string" ? document.querySelector(selector) : selector;
        gtag.push("event", GTagEvent_1["default"].SHOW_BANNER);
        if (selectorElement) {
            var goodsAndServicesPrice = productBannerPayload.goodsAndServicesPrice, calculatedProduct_1 = productBannerPayload.calculatedProduct;
            // check payment method availability based on price
            var paymentMethods = 
            // filter only paymentMethods that are available for given price
            this.getAvailablePaymentMethodsForItemPrice(goodsAndServicesPrice)
                // remove rozlozto if calculated product is not available
                .filter(function (paymentMethod) { return (paymentMethod.code !== PaymentMethodCode_1["default"].ROZLOZ_TO) || calculatedProduct_1; });
            var showBanner = paymentMethods.length > 0; // at least one product is available
            var renderElement = showBanner
                ? (0, jsx_runtime_1.jsx)(ProductBanner_1["default"], { availablePaymentMethods: paymentMethods, calculatedProduct: calculatedProduct_1, onModalOpen: function () { return gtag.push("event", GTagEvent_1["default"].SHOW_HOW_IT_WORKS); } })
                : null; // clear element if no payment method available (in case of re-render)
            (0, preact_1.render)(renderElement, selectorElement);
            return true;
        }
        return false;
    };
    Ahoj.prototype.renderPaymentMethodDescription = function (selector, checkoutPayload, paymentMethodCode) {
        var _a;
        var calculatedProduct = checkoutPayload.calculatedProduct, goodsAndServicesPrice = checkoutPayload.goodsAndServicesPrice;
        var selectorElement = typeof selector === "string" ? document.querySelector(selector) : selector;
        gtag.push("event", GTagEvent_1["default"].SHOW_PAYMENT_METHOD_DESCRIBE);
        // check payment method availability based on price
        var paymentMethod = this.getAvailablePaymentMethods().find(function (paymentMethod) { return paymentMethod.code === paymentMethodCode; });
        var available = (paymentMethod ? this.getPaymentMethodAvailability(paymentMethod.code, goodsAndServicesPrice) : { available: false }).available;
        if (selectorElement && available && paymentMethod) {
            // if checkoutPayload.disabled is defined, then use it, otherwise calculate whether payment method is available for given price
            var disabled = typeof checkoutPayload.disabled === "boolean" ? checkoutPayload.disabled : !PaymentMethods.isAvailableForPrice(paymentMethod, goodsAndServicesPrice);
            var methodDescriptionToRender = (_a = {},
                _a[PaymentMethodCode_1["default"].ODLOZ_TO] = PaymentMethodDescriptionOdlozTo_1["default"],
                _a[PaymentMethodCode_1["default"].ROZLOZ_TO] = PaymentMethodDescriptionRozlozTo_1["default"],
                _a);
            var DescriptionElement = methodDescriptionToRender[paymentMethod.code];
            var renderElement = (0, jsx_runtime_1.jsx)(DescriptionElement, { disabled: disabled, paymentMethod: paymentMethod, calculatedProduct: calculatedProduct });
            (0, preact_1.render)(renderElement, selectorElement);
            return true;
        }
        return false;
    };
    Ahoj.prototype.setPaymentMethodDescriptionVisibility = function (selector, visible) {
        var selectorHTMLElement = typeof selector === "string" ? document.querySelector(selector) : selector;
        if (selectorHTMLElement) {
            selectorHTMLElement.style.display = visible ? "block" : "none";
        }
    };
    Ahoj.prototype.getPaymentMethodAvailability = function (paymentMethodCode, price) {
        var paymentMethod = this.getAvailablePaymentMethods().find(function (paymentMethod) { return paymentMethod.code === paymentMethodCode; });
        return {
            available: paymentMethod !== undefined,
            disabled: paymentMethod ? !PaymentMethods.isAvailableForPrice(paymentMethod, price) : null
        };
    };
    Ahoj.prototype.openApplicationIframe = function (url) {
        var appendIframe = function () {
            var $iframeContainer = document.createElement("div");
            document.body.appendChild($iframeContainer);
            var removeIframe = function () { return (0, preact_1.render)(null, $iframeContainer); };
            (0, preact_1.render)((0, jsx_runtime_1.jsx)(ApplicationIframe_1["default"], { show: true, src: url, onClose: function () { return removeIframe(); }, onGtag: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    return gtag.push(args);
                } }), $iframeContainer);
        };
        var $body = document.body;
        if ($body) {
            appendIframe();
        }
        else {
            document.addEventListener("DOMContentLoaded", appendIframe);
        }
    };
    Ahoj.prototype.renderPaymentMethodTitle = function (selector, paymentMethodCode) {
        var selectorElement = typeof selector === "string" ? document.querySelector(selector) : selector;
        // if selector is not found, return false
        if (!selectorElement) {
            throw new Error("Payment method title selector ".concat(selector, " not found"));
        }
        selectorElement.innerHTML = this.getPaymentMethodTitle(paymentMethodCode);
        return true;
    };
    Ahoj.prototype.getAvailablePaymentMethods = function () {
        return this.availablePaymentMethods;
    };
    Ahoj.prototype.getPaymentMethodTitle = function (paymentMethodCode) {
        var paymentMethod = this.getAvailablePaymentMethods().find(function (paymentMethod) { return paymentMethod.code === paymentMethodCode; });
        if (!paymentMethod) {
            throw new Error("Payment method with code ".concat(paymentMethodCode, " is not available"));
        }
        return paymentMethod.title;
    };
    Ahoj.PAYMENT_METHOD_CODE = {
        ODLOZ_TO: PaymentMethodCode_1["default"].ODLOZ_TO,
        ROZLOZ_TO: PaymentMethodCode_1["default"].ROZLOZ_TO
    };
    return Ahoj;
}());
exports["default"] = Ahoj;
